const DOCUMENT_TYPE_ALIASES: Record<string, string> = {
  'referral/referrals': 'referral',
  'pathology result': 'pathology report',
  'pathology results': 'pathology report',
  'pathology reports': 'pathology report',
};

export function getDocumentTypeLabel(emailType: string, documentCount = 1): string {
  if (!emailType?.trim()) {
    return '';
  }

  const normalised = emailType.trim().toLowerCase();
  const singular = DOCUMENT_TYPE_ALIASES[normalised] ?? singularise(normalised);

  if (documentCount === 1) {
    return singular;
  }

  return pluralise(singular);
}

export function formatDocumentTypeForBody(emailType: string, documentCount = 1): string {
  const label = getDocumentTypeLabel(emailType, documentCount);

  if (!label) {
    return '';
  }

  return label
    .split('/')
    .map(part => formatSegmentForBody(part.trim()))
    .join('/');
}

export function formatDocumentTypeForSubject(emailType: string, documentCount = 1): string {
  const bodyForm = formatDocumentTypeForBody(emailType, documentCount);

  if (!bodyForm) {
    return '';
  }

  return bodyForm.charAt(0).toUpperCase() + bodyForm.slice(1);
}

function formatSegmentForBody(value: string): string {
  if (!value) {
    return '';
  }

  return value
    .split(/(\s+)/)
    .map(token => {
      if (!token || /^\s+$/.test(token)) {
        return token;
      }

      return token.toLowerCase();
    })
    .join('');
}

function singularise(value: string): string {
  const trimmed = value.trim();
  const lower = trimmed.toLowerCase();

  if (lower.endsWith('ies')) {
    return `${trimmed.slice(0, -3)}y`;
  }

  if (lower.endsWith('s') && !lower.endsWith('ss')) {
    return trimmed.slice(0, -1);
  }

  return trimmed;
}

function pluralise(value: string): string {
  const trimmed = value.trim();
  const lower = trimmed.toLowerCase();

  if (lower.endsWith('y') && !/[aeiou]y$/.test(lower)) {
    return `${trimmed.slice(0, -1)}ies`;
  }

  if (lower.endsWith('s')) {
    return trimmed;
  }

  return `${trimmed}s`;
}
